module.exports = __webpack_public_path__ + "img/cloud-arrow-down.916d12a6.svg";